import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsSeoWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsSeoState } from './types';

export interface SportsSeoWidgetModel
  extends WidgetModelConfig<SportsSeoWidgetConfig, SportsSeoState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsSeoWidgetModel: SportsSeoWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsSeoWidget: UseWidget<SportsSeoWidgetConfig, SportsSeoWidgetModel> = useWidget;
